import createIcon from '../../createIcon';

/**
 * @component @name DriveFolderUpload
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNkgxMkwxMCA0SDRDMi45IDQgMi4wMSA0LjkgMi4wMSA2TDIgMThDMiAxOS4xIDIuOSAyMCA0IDIwSDIwQzIxLjEgMjAgMjIgMTkuMSAyMiAxOFY4QzIyIDYuOSAyMS4xIDYgMjAgNlpNMjAgMThINFY4SDIwVjE4Wk04IDEzLjAxTDkuNDEgMTQuNDJMMTEgMTIuODRWMTdIMTNWMTIuODRMMTQuNTkgMTQuNDNMMTYgMTMuMDFMMTIuMDEgOUw4IDEzLjAxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DriveFolderUpload = createIcon('DriveFolderUpload', [
  [
    'path',
    {
      d: 'M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V8H20V18ZM8 13.01L9.41 14.42L11 12.84V17H13V12.84L14.59 14.43L16 13.01L12.01 9L8 13.01Z',
      key: '1r8ppy',
    },
  ],
]);

export default DriveFolderUpload;
